import script from "./TableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableCell.vue?vue&type=script&lang=ts&setup=true"

import "./TableCell.vue?vue&type=style&index=0&id=44d04e0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d04e0d"]])

export default __exports__